export const AUTHENTICATION_REQUEST="AUTHENTICATION_REQUEST";
export const AUTHENTICATION_SUCCESS="AUTHENTICATION_SUCCESS";
export const AUTHENTICATION_FAILURE="AUTHENTICATION_FAILURE";


export const LOGOUT_REQUEST="LOGOUT_REQUEST";
export const LOGOUT_SUCCESS="LOGOUT_SUCCESS";
export const LOGOUT_FAILURE="LOGOUT_FAILURE";